var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalAdvertencia",attrs:{"titulo":"Advertencia","adicional":_vm.textBoton},on:{"adicional":_vm.accion}},[_c('div',{staticClass:"row mx-0 j-center mb-3"},[_c('div',{staticClass:"col-auto text-center text-general f-15"},[_vm._v(" "+_vm._s(_vm.mensaje)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }